import React from 'react';
import PropTypes from "prop-types";
import {ALLOWED_TOKEN} from "../../constants/dataConstants";
import ArgoAutocompleteHook from "./ArgoAutocompleteHook";
import ArgoSelectPortalTextDisplayTypeHook from "./ArgoSelectPortalTextDisplayTypeHook";
import ArgoTextDisplayCustomHook from "./ArgoTextDisplayCustomHook";

const ArgoTextEntryWithCustomOverride = (props) => {
    const {
        hideText,
        templateType,
        textEntryType,
        fieldName,
        fieldTextObjName,
        autoFocus,
        errorText,
        maxlength,
        label,
        labelCustom,
        initTo,
        initToObj,
        hideOnly,
        hideOption,
        propsObj,
        index,
        showQuestionNum,
        showIndent
    } = props;

    const fileName = propsObj.fileName;

    let value = "";

    if (textEntryType.includes("user-script")) {
        if (propsObj.metadata.hasOwnProperty(fieldName)) {
            value = propsObj.metadata[fieldName];
        }
    } else {
        value = propsObj.template[fieldName];
    }

    return (
        <div id="ArgoTextEntryWithCustomOverride-container-div" style={{width: "100%"}}>
            <div id={"ArgoTextEntryWithCustomOverride-" + fileName + "-" + fieldName + "-container-div"} style={{display: "flex", flexDirection: "row", width: "100%"}}>
                {!hideText &&
                    <ArgoAutocompleteHook
                        fileName={fileName}
                        fieldName={fieldName}
                        index={index}
                        label={label}
                        autoFocus={autoFocus}
                        onChange={propsObj.onTextChange}
                        value={value}
                        menuItems={ALLOWED_TOKEN}
                        maxLength={maxlength}
                        error={errorText !== " "}
                        errorText={errorText === " " ? " " : errorText}
                        multiline={true}
                        width="96%"
                    />
                }

                <ArgoSelectPortalTextDisplayTypeHook
                    templateType={templateType}
                    textEntryType={textEntryType}
                    fieldName={fieldName}
                    fieldTextObjName={fieldTextObjName}
                    index={index}
                    initTo={initTo}
                    hideOnly={hideOnly}
                    hideOption={hideOption}
                    metadataPropsObj={propsObj}
                />
            </div>

            <div id={fileName + "-script-container-div"}>
                {(initTo === 'custom') ?
                    <ArgoTextDisplayCustomHook
                        templateType={templateType}
                        textEntryType={textEntryType}
                        fieldName={fieldName}
                        fieldTextObjName={fieldTextObjName}
                        initToObj={initToObj}
                        displayLabel={labelCustom}
                        metadataPropsObj={propsObj}
                        showQuestionNum={showQuestionNum}
                        showIndent={showIndent}
                    />
                    :
                    <div></div>
                }
            </div>

            <div>&nbsp;</div>
        </div>
    );
};

ArgoTextEntryWithCustomOverride.defaultProps = {
    hideText: false,
    maxlength: 255,
    errorText: " ",
    hideOption: true,
    hideOnly: false,
    index: 0,
    showQuestionNum: false,
    showIndent: false
};

ArgoTextEntryWithCustomOverride.propTypes = {
    hideText: PropTypes.bool,
    templateType: PropTypes.string,
    textEntryType: PropTypes.string, // templateType and textEntryType determine the text default properties.
    fileName: PropTypes.string,
    fieldName: PropTypes.string,
    fieldTextObjName: PropTypes.string,
    errorText: PropTypes.string,
    maxlength: PropTypes.number,
    label: PropTypes.string,
    labelCustom: PropTypes.string,
    value: PropTypes.string,
    initTo: PropTypes.string,
    initToObj: PropTypes.object,
    hideOnly: PropTypes.bool,  // Categories only, if category is a title bar then all the text entries can be only HIDDEN
    hideOption: PropTypes.bool,
    propsObj: PropTypes.object,
    index: PropTypes.number,
    showQuestionNum: PropTypes.bool,
    showIndent: PropTypes.bool
};

export default ArgoTextEntryWithCustomOverride;
